import * as angular from 'angular';
import { getCognitoToken } from 'angular/utils/cognito';
import { config } from 'angular/utils/config';
import * as moment from 'pkp-moment-timezone-all-years';
import { TsoNotificationResource } from 'app/tso-notifications/tso-notification.resource';

class TsoNotificationOverviewComponentCtrl implements ng.IController {
    private static readonly QUERY_LAST_DAYS = 30;

    public tsoNotifications: TsoNotificationDto[];
    public appBaseUrl: string = config.appBaseUrl;
    public loadingError: boolean = false;
    public loadingData: boolean = true;
    public notificationsHaveBeenAvailableInitially: boolean;
    public showNewNotifications: boolean = false;

    constructor(private tsoNotificationResource: TsoNotificationResource) {}

    public $onInit(): void {
        const checkAuth = async () => {
            // if we have token we know we're authenticated
            const token = await getCognitoToken();
            if (token) this.showNewNotifications = true;
        };
        checkAuth();
        this.tsoNotificationResource
            .queryAllForTso(
                { sinceDate: this.calculateDate() },
                (res: TsoNotificationDto[]) => {
                    this.tsoNotifications = res;
                    this.loadingError = false;
                    this.loadingData = false;
                },
                () => {
                    this.loadingError = true;
                    this.loadingData = false;
                }
            )
            .$promise.finally(() => {
                this.notificationsHaveBeenAvailableInitially =
                    this.tsoNotifications.length > 0;
            });
    }

    private calculateDate(): Date {
        return moment()
            .subtract(
                TsoNotificationOverviewComponentCtrl.QUERY_LAST_DAYS,
                'days'
            )
            .toDate();
    }
}

angular.module('app').component('pkpTsoNotificationOverview', {
    controller: TsoNotificationOverviewComponentCtrl,
    template:
        require('app/tso-notifications/tso-notification-overview.component.html'),
    bindings: {}
});
